import React, { Component } from "react";
import Form from "react-jsonschema-form";
import {Button ,Well,ButtonGroup,Glyphicon,ToggleButtonGroup,ToggleButton,ControlLabel,FormGroup,FormControl,HelpBlock,InputGroup} from "react-bootstrap";

import {ActionsDisplay} from "./ActionsDisplay"
import ActionCreate from './ActionCreate'
import ReactDragList from 'react-drag-list'
import Moment from 'react-moment';
import moment from "moment"

/*
0:
address: 1
channel: 0
ctrlType: "RELAY PACK"
dest: "PAGER_ALTIOM"
id: 0
name: "Relay A1 Channel 1"
outputHandler: "local485"
type: "ON/OFF"

*/


function OutControls(data){
  let callback=data.callback

  //console.log("OUTCONTROLS")
//  console.log(data)
  if(data.data.ctrlType=="RELAY PACK" || data.data.ctrlType=="DECT SOCKET" || data.data.ctrlType=="RF_SOCKET")
    return (<span className="pull-right"><Button  bsSize="xsmall" onClick={() =>callback({"cmd":"action",data:{"cmd":"outputCtrl","outputID":data.data.id,type:"on","data":data.data}})   }>ON</Button>
                  <Button  bsSize="xsmall" onClick={() =>callback({"cmd":"action",data:{"cmd":"outputCtrl","outputID":data.data.id,type:"off","data":data.data}})   }>OFF</Button>
                  <Button  bsSize="xsmall" onClick={() =>callback({"cmd":"action",data:{"cmd":"outputCtrl","outputID":data.data.id,type:"toggle","data":data.data}})   }>TOGGLE</Button>
            </span>)
  if(data.data.ctrlType=="RGB STRIP")
    return (<span className="pull-right">
          <Button  bsSize="xsmall" onClick={() =>callback({"cmd":"action",data:{"cmd":"outputCtrl","outputID":data.data.id,type:"ramp","data":{address:data.data.address,red:255,green:0,blue:0,time:1}}})   }>Red</Button>
          <Button  bsSize="xsmall" onClick={() =>callback({"cmd":"action",data:{"cmd":"outputCtrl","outputID":data.data.id,type:"ramp","data":{address:data.data.address,red:0,green:255,blue:0,time:1}}})   }>Green</Button>
          <Button  bsSize="xsmall" onClick={() =>callback({"cmd":"action",data:{"cmd":"outputCtrl","outputID":data.data.id,type:"ramp","data":{address:data.data.address,red:0,green:0,blue:255,time:1}}})   }>Blue</Button>
          <Button  bsSize="xsmall" onClick={() =>callback({"cmd":"action",data:{"cmd":"outputCtrl","outputID":data.data.id,type:"ramp","data":{address:data.data.address,red:0,green:0,blue:0,time:1}}})   }>Off</Button>
          </span>)
    return("")


}


export default class OutputDevice extends Component {
    constructor(props) {
      super(props);
      this.state = {
        initialName:props.data.name,
        initialAddr:parseInt(props.data.address),
        initialChn:parseInt(props.data.channel),
        rgbAlert:props.data.alertLed,
        outEdit:false
      };

    }

  componentWillMount() {

  }

  toggleAlert=()=>{

    console.log("Alert Toggle")
    this.setState({rgbAlert:!this.state.rgbAlert})
  }

editOutName=()=>{
    this.setState({outEdit:true})
}
saveOutputName=()=>{

  console.log(this.state.initialName)

  let data=this.props.data
  data["name"]=this.state.initialName
  data["channel"]=parseInt(this.state.initialChn)
  data["address"]=parseInt(this.state.initialAddr)



  if("alertLed" in data){
    data["alertLed"]=this.state.rgbAlert
  }
  this.props.callback({
    cmd:"output",
    type:"update",
    data:data
  })
  this.setState({outEdit:false})
}

deleteOutput=()=>{
  let data=this.props.data
  this.props.callback({
    cmd:"output",
    type:"delete",
    data:data
  })
  this.setState({outEdit:false})



}

showHelp=()=>{
  this.props.callback({
    cmd:"output",
    type:"helpRF",
  })

}


closeOutputName=()=>{
this.setState({outEdit:false})

}

changeSetting=(e)=>{
  console.log(e.target.value)
  console.log(e.target.name)

  let update={}
  update[e.target.name]=e.target.value
  this.setState(update)
  console.log(update)
}

changeName=(e)=>{
  this.setState({initialName:e.target.value})

}



    render(){
      return <Well bsSize="small">
      {this.state.outEdit ? (
        <div>
        Name
        <input value={this.state.initialName} onChange={this.changeName}></input>


        {this.props.data.ctrlType=="RF_SOCKET" ?(<div>

        GROUP 0-255<input type="number"    min={0} max={255}   value={this.state.initialAddr} name="initialAddr" onChange={this.changeSetting} ></input>
        CHANNEL 0-255<input type="number"  min={0} max={255}   value={this.state.initialChn}  name="initialChn"  onChange={this.changeSetting} ></input>


          </div>
          ):("")}

          {this.props.data.ctrlType=="RELAY PACK" ?(<div>
          ADDRESS 0-256<input type="number"    min={0} max={256}   value={this.state.initialAddr} name="initialAddr" onChange={this.changeSetting} ></input>
          CHANNEL 0-8<input type="number"  min={0} max={8}   value={this.state.initialChn}  name="initialChn"  onChange={this.changeSetting} ></input>
            </div>
            ):("")}


        <Button onClick={()=>this.saveOutputName()}>Done</Button><Button onClick={()=>this.closeOutputName()}>Cancel</Button>
        <Button onClick={()=>this.deleteOutput()}>Delete</Button>
  {this.props.data.ctrlType=="RF_SOCKET" ?(
<div className="pull-right">
<Button onClick={()=>this.showHelp()}>Help</Button>
</div>):(<span></span>)}
        {this.props.data.ctrlType=="RGB STRIP" ?(<div className="pull-right">
            {this.state.rgbAlert ? (<span onClick={()=>this.toggleAlert()}>Alert Mode Enabled</span>):(<span onClick={()=>this.toggleAlert()}>Alert Mode Disabled</span>)}
          </div>
          ):("")}
        </div>
      ):(
        <div>
        <h4>{this.props.data.name}&nbsp;<Glyphicon onClick={()=>this.editOutName()} title="Edit name" className="iconBut" glyph="pencil" />
        <OutControls data={this.props.data} callback={this.props.callback}/></h4>
      </div>)
      }
      </Well>





    }
}



// WEBPACK FOOTER //
// ./src/programmerComponents/OutputDevices.js